import React from 'react';
import generateAttributes from "../../functions/generateAttributes";
import "../../styles/components/PersonCard.scss";

function PersonCard ({ name, title, imageUrl, ...props }) {
    const attr = generateAttributes("PersonCard", props);

    return (
            <div {...attr()}>
                <div {...attr("imageContainer")}>
                    <img {...attr("image")}
                        src={imageUrl}
                        alt={name}
                    />
                </div>

                <div {...attr("cardContent")}>
                    <h2 {...attr("cardTitle")}>
                        {name}
                    </h2>
                    <p {...attr("cardText")}>
                        {title}
                    </p>
                </div>
            </div>
    );
};

export default PersonCard;